import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Auth } from 'src/app/models/auth';
import { ConductorCollaborator, ConductorCollaboratorFilter } from 'src/app/models/conductors';
import { Vehicle } from 'src/app/models/vehicle';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ConductorService } from 'src/app/services/conductor.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-condutor-list',
  templateUrl: './condutor-list.component.html',
  styleUrls: ['./condutor-list.component.css']
})
export class CondutorListComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private alertService: NewAlertService,
    private conductorService: ConductorService,
    private authenticationService: AuthenticationService,
  ) { }

  private currentUser: Auth;
  public conductors: ConductorCollaborator[];
  public conductorsSelected: any = [];
  public vehicleGuid: string;
  public filterOn = false;

  public filters = new ConductorCollaboratorFilter;

  // páginação
  currentPage = 1;
  showItem = '10';
  totalItems = 0;

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;

    this.pagedConductor(1);
  }

  pagedConductor(page) {

    this.currentPage = page;
    const offset = (this.currentPage - 1);

    this.conductorService.getCollaboratorConductors(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId, offset, +this.showItem, this.filters)
      .subscribe(response => {
        if (response.status === ApiError.Sucesso) {
          this.conductors = response.result.items;

          this.conductors.forEach(element => {
            if (element.document != null) {
              const tam = environment.TOTAL_CARACTERE_CPF - element.document.length;
              for (let i = 0; i < tam; i++) {
                element.document = '0' + element.document;
              }
            }
          });

          this.totalItems = response.result.totalItems;
        }
      });
  }

  showItemChanged(event) {
    this.showItem = event;
    this.pagedConductor(1);
  }

  showFilter(content: any) {
    this.modalService.open(content, { centered: true, size: 'lg' });
  }

  applyFilter() {
    this.filterOn = !(
      (this.filters.cnh == null || this.filters.cnh == '') &&
      (this.filters.name == null || this.filters.name == '') &&
      (this.filters.document == null || this.filters.document == '') &&
      (this.filters.register == null || this.filters.register == '')
    )
    this.pagedConductor(1);
  }

  deleteFilter() {
    this.filters = new ConductorCollaboratorFilter;

    this.filterOn = false;

    this.pagedConductor(1);
  }

  selectElement(item: ConductorCollaborator) {
    this.conductors.find(e => e.id === item.id).selected = item.selected;

    if (item.selected) {
      this.conductorsSelected.push(item.id);
    } else {
      this.conductorsSelected = this.conductorsSelected.filter(e => e !== item.id);
    }
  }

  goToBack() {
    this.router.navigate([`list`], { queryParams: { id: this.vehicleGuid }, relativeTo: this.route.parent });
  }

  link() {
    this.conductorService.linkConductorsVehicle(this.currentUser.token.assignorGuid, this.vehicleGuid, this.currentUser.token.userReferenceId, this.conductorsSelected)
      .subscribe(response => {
        if (response.status === ApiError.Sucesso) {
          this.conductorsSelected = [];
          this.goToBack();
          this.alertService.success("Condutor(es) vinculados com sucesso!");
        } else {
          this.alertService.error("Falha ao vincular condutor(es)");
        }
      }, error => {
        this.alertService.error("Falha ao vincular condutor(es)");
      });
  }

  linkedVehicle(item: Vehicle[]) {
    return item.find(e => e.vehicleGuid === this.vehicleGuid)?.id > 0;
  }

  create() {
    this.router.navigate(['create'], { relativeTo: this.route.parent });
  }

  edit(id){
      this.router.navigate([`edit/${id}`], {relativeTo: this.route.parent});
  }

}
